/* eslint-disable import/exports-last */
import classNames from 'classnames'
import styles from './Expandable.module.css'
import {
  type CSSProperties,
  type ReactNode,
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
export type ExpandableProps = {
  children?: ReactNode
  open: boolean
  className?: string
  contentClassName?: string
}
export type ExpandableRef = { checkSize: () => void }
const Expandable = forwardRef<ExpandableRef, ExpandableProps>(function Expandable(
  { children, open, className, contentClassName }: ExpandableProps,
  forwardedRef
) {
  const ref = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<number>(0)
  const setHeightFromRef = useCallback(() => {
    if (!ref.current) return
    const element = ref.current
    setHeight(element.scrollHeight)
  }, [])
  useImperativeHandle(forwardedRef, () => ({
    checkSize: setHeightFromRef,
  }))

  useEffect(() => {
    if (!open) return
    setHeightFromRef()
    window.addEventListener('resize', setHeightFromRef)
    return () => {
      window.removeEventListener('resize', setHeightFromRef)
    }
  }, [setHeightFromRef, open])

  return (
    <div
      className={classNames(styles.container, className, { [styles.open!]: open })}
      style={{ '--height': `${height}px` } as CSSProperties}
    >
      <div className={classNames(styles.content, contentClassName)} ref={ref}>
        {children}
      </div>
    </div>
  )
})

export default Expandable
